"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statsSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const platform_types_1 = require("../core/platform.types");
const placementTest_1 = require("./placementTest");
exports.statsSchema = zod_1.default.object({
    streak: zod_1.default.number(),
    wordsLearned: zod_1.default.object({
        total: zod_1.default.number(),
        lastWeek: zod_1.default.number(),
        lastMonth: zod_1.default.number(),
    }),
    conversationMinutesSpent: zod_1.default.object({
        lastMonthMinutes: zod_1.default.number(),
        lastWeekMinutes: zod_1.default.number(),
        totalMinutes: zod_1.default.number(),
    }),
    lesson: zod_1.default.object({
        levelProgress: zod_1.default.number(),
        totalProgress: zod_1.default.number(),
    }),
    proficiencyLevel: zod_1.default.string(),
    activity: zod_1.default.object({
        totalFinished: zod_1.default.number(),
    }),
    placementTest: zod_1.default
        .object({
        finishedAt: zod_1.default.date().optional(),
        result: placementTest_1.placementTestResultSchema.optional(),
        platform: zod_1.default.nativeEnum(platform_types_1.PlatformEnum),
    })
        .nullable(),
    newCertificatesCount: zod_1.default.number(),
});
//# sourceMappingURL=stats.js.map